import { Card, CardContent } from '@components/ui/Card';
import { Users, Mail } from 'lucide-react';

export default function AboutUsPage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">Über uns</h1>
          <p className="text-lg text-slate-400">Das Team des Aktionsbündnisses</p>
        </div>

        {/* Content */}
        <div className="space-y-6">
          <Card>
            <CardContent className="p-6">
              <p className="text-slate-300 leading-relaxed mb-6">
                Das Aktionsbündnis ist ein Zusammenschluss von Institutionen, Vereinen und
                Privatpersonen aus Mannheim, denen der Erhalt der Alten Sternwarte Mannheim am
                Herzen liegt. Es entstand im Juli 2010 mit ca. 20 Personen, aus dem sich in den
                folgenden Jahren das bürgerliche &quot;Aktionsbündnis Alte Sternwarte&quot;
                entwickelte.
              </p>

              <p className="text-slate-300 leading-relaxed mb-6">
                Seit 2016 gehört das Aktionsbündnis als eigenständiges Projekt zum Verein
                Stadtbild Mannheim e.V. Ein Team von 10 Personen, unterstützt vom MARCHIVUM,
                den REM sowie dem Planetarium Mannheim plant und führt die Veranstaltungen und
                Lesungen in der Sternwarte – und in der kalten Jahreszeit an anderen Orten in
                der Stadt – durch.
              </p>
            </CardContent>
          </Card>

          {/* Join Us */}
          <div className="bg-gradient-to-r from-blue-900/20 to-purple-900/20 rounded-xl p-6 border border-blue-800/30">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-blue-600/10 rounded-lg flex items-center justify-center shrink-0">
                <Users className="text-blue-400" size={24} />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white mb-3">Werden Sie Teil unseres Teams</h2>
                <p className="text-slate-300 mb-4">
                  Wenn Sie Interesse haben, sich ehrenamtlich mit in das Team einzubringen und
                  uns bei den Veranstaltungen zu unterstützen, dann melden Sie sich beim
                  Aktionsbündnis. Wir freuen uns darüber.
                </p>
                <a
                  href="mailto:kontakt@sternwarte-mannheim.de"
                  className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors"
                >
                  <Mail size={18} />
                  kontakt@sternwarte-mannheim.de
                </a>
              </div>
            </div>
          </div>

          {/* Partners */}
          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-bold text-white mb-4">Unsere Partner</h2>
              <ul className="space-y-3">
                <li className="flex items-center gap-2 text-slate-300">
                  <span className="w-2 h-2 bg-blue-500 rounded-full" />
                  MARCHIVUM – Mannheimer Stadtarchiv
                </li>
                <li className="flex items-center gap-2 text-slate-300">
                  <span className="w-2 h-2 bg-purple-500 rounded-full" />
                  Reiss-Engelhorn-Museen (REM)
                </li>
                <li className="flex items-center gap-2 text-slate-300">
                  <span className="w-2 h-2 bg-amber-500 rounded-full" />
                  Planetarium Mannheim
                </li>
                <li className="flex items-center gap-2 text-slate-300">
                  <span className="w-2 h-2 bg-green-500 rounded-full" />
                  Verein Stadtbild Mannheim e.V.
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
